import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NguFormFieldComponent } from './ngu-form-field/ngu-form-field.component';
import {
  NguErrorDirective,
  NguInputDirective,
  NguFormTextDirective
} from './ngu-input.directive';
import { NguInputComponent } from './ngu-input/ngu-input.component';
import { NguSelectComponent } from './ngu-select/ngu-select.component';
import { NguErrorComponent } from './ngu-error/ngu-error.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [
    NguSelectComponent,
    NguInputComponent,
    NguFormFieldComponent,
    NguInputDirective,
    NguErrorDirective,
    NguErrorComponent,
    NguFormTextDirective
  ],
  exports: [
    NguSelectComponent,
    NguInputComponent,
    NguFormFieldComponent,
    NguInputDirective,
    NguErrorDirective,
    NguErrorComponent,
    NguFormTextDirective
  ]
})
export class NguFormsModule {}
